// extracted by mini-css-extract-plugin
export default {"weather-info":"WeatherInfo_weather-info__CvZul"};